import { useEffect, useState } from "react";
import { useAnalytics } from "app/utils/analytics/useAnalytics";

// for 1 2 and 3, @see https://developer.mozilla.org/en-US/docs/Web/API/GeolocationPositionError/code
const GEOLOCATION_POSITION_ERRORS = {
	1: "PERMISSION_DENIED",
	2: "POSITION_UNAVAILABLE",
	3: "TIMEOUT",
	4: "API_NOT_SUPPORTED",
};

export default ({ enable }) => {
	const { track } = useAnalytics();
	const [latitude, setLatitude] = useState();
	const [longitude, setLongitude] = useState();

	useEffect(() => {
		if (enable) {
			if ("geolocation" in navigator) {
				navigator.geolocation.getCurrentPosition(
					position => {
						setLatitude(position.coords.latitude);
						setLongitude(position.coords.longitude);
					},
					error => {
						track("geolocation_permission_error", {
							code: GEOLOCATION_POSITION_ERRORS[error.code],
						});
					},
					{
						enableHighAccuracy: true,
						maximumAge: 3600000,
						timeout: 30000,
					}
				);
			} else {
				track("geolocation_permission_error", {
					code: GEOLOCATION_POSITION_ERRORS[4],
				});
			}
		}
	}, [enable]);

	return {
		latitude,
		longitude,
	};
};
